const Client = require("../modules/ModHttpsClient")

module.exports = {
    send(data) {
        return Client.post(data, {
            path: "/client/error"
        })
    }
}